import {DmsRequest} from '../common/dms-request';
import {FunctionalHeader} from '../common/functional-header';
import {TechnicalHeaderInRequest} from '../common/technical-header-in-request';
import {UserInformation} from '../common/user-information';
import {GetServiceOrderRequestBody} from './get-service-order-request-body';

export class GetServiceOrderRequest implements DmsRequest {
  readonly simpleName = 'get-order';
  technicalHeader: TechnicalHeaderInRequest;
  functionalHeader: FunctionalHeader;
  userInformation: UserInformation;
  body: GetServiceOrderRequestBody;
}

